import { createAction, props } from '@ngrx/store';

export const OpenListsSidenav = createAction('[Lists: Sidenav]: Sidenav Opened');


export const ShowPreviewList = createAction('[Lists: Sidenav]: Show Preview List');

export const ShowCampaignExecutions = createAction('[Campaign Search: Sidenav]: Show Campaign Executions', props<{campaign: any}>());

export const CloseSidenav = createAction('[Sidenav]: Sidenav Close');
